import { render, staticRenderFns } from "./_oid.vue?vue&type=template&id=2031c49a"
import script from "./_oid.vue?vue&type=script&lang=js"
export * from "./_oid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartConfirmViewsDefault: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/cart/confirm/views/Default.vue').default})
